import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { InfoboxComponent } from '@core/components-infobox-legacy';
// eslint-disable-next-line boundaries/element-types -- FIXME
import { injectDevFlag } from '@core/dev-flags-logic';
import { DevFlag } from '@core/dev-flags-types';
import { TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'rt-mailbox-infobox-internal-emails',
  templateUrl: './mailbox-infobox-internal-emails.component.html',
  styleUrl: './mailbox-infobox-internal-emails.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InfoboxComponent, TranslatePipe],
})
export class MailboxInfoboxInternEmailsComponent {
  public emails = input.required<string[]>();
  public dismiss = output();

  public emailsStr = computed(() => this.emails().join(', '));

  protected emailSyncingProtection = injectDevFlag(DevFlag.EmailSyncingProtection);

  protected messageTranslationKey = computed(() =>
    this.emailSyncingProtection
      ? 'app.mailbox.candidate_with_internal_email_infobox.message_v2'
      : 'app.mailbox.candidate_with_internal_email_infobox.message',
  );
}
